import './comment-row.css'

import { FC, useEffect, useState } from 'react'

import { ButtonV2 } from '../../atoms/button-v2'
import { Divider } from '../../atoms/divider'
import { TextArea } from '../../form/textarea'
import { Text } from '../../typography/text'

import { CommentRowTypeV2 } from './comment-row.types'
import DeleteModal from './components/delete-comment.modal'

import { returnDate, returnTime } from '@lua-frontend/utils'
import { DeleteIcon } from '../../assets'
import { formatCommentWithLinks } from '../../utils/helpers.jsx'


const CommentRow: FC<CommentRowTypeV2> = ({
  handleSave,
  comments,
  handleDelete,
  heading,
  placeholder,
  submitButtonText = 'Save',
  cancelButtonText = 'Cancel',
  deleteModalTitle = 'Delete comment?',
  deleteModalDescription = 'This action can not be undone',
  deleteButtonText = 'Delete',
  showDeleteButton = false,
  authorId,
  addTopDivider = true,
  textAreaClasses,
  commentRowHeight = '35px',
  deleteButtonPosition = 'left',
}) => {
  //save button loader state
  const [buttonLoader, setButtonLoader] = useState(false)
  const [buttonDisabled, setButtonDisabled] = useState(false)
  const [comment, setComment] = useState('')
  const [showButtons, setShowButtons] = useState(false)
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false)

  const [selectedComment, setSelectedComment] = useState<
    string | number | null
  >(null)

  useEffect(() => {
    if (comment.length > 0) {
      setShowButtons(true)
    } else {
      setShowButtons(false)
    }
  }, [comment])

  const handleCancel = () => {
    setComment('')
    setShowButtons(false)
  }

  const saveComment = async () => {
    if (handleSave) {
      setButtonLoader(true)
      setButtonDisabled(true)
      const result = await handleSave(comment)
      if (result) {
        setComment('')
      }
      setButtonLoader(false)
      setButtonDisabled(false)
    }
  }

  const closeDeleteModal = () => {
    setShowDeleteModal(false)
    setSelectedComment(null)
  }

  return (
    <div className="flex w-full flex-col">
      {addTopDivider && (
        <div className="mx-2">
          <Divider />
        </div>
      )}
      <div className="mb-1 ml-2 mt-2">
        <Text label={heading} type="button" />
      </div>
      <div className="mx-2 mb-2">
        <TextArea
          placeholder={placeholder}
          value={comment}
          handleChange={(e) => setComment(e.target.value)}
          name="comment text area"
          className={textAreaClasses}
          customHeight={commentRowHeight}
        />
      </div>
      {showButtons && (
        <div
          className={`mx-2 flex ${
            comments && comments.length > 0 ? 'my-0' : 'my-2'
          }`}
        >
          <div className="mr-2">
            <ButtonV2
              label={submitButtonText}
              variant="primary"
              disabled={comment.trim().length === 0}
              loading={buttonLoader}
              handleClick={saveComment}
            />
          </div>
          <ButtonV2
            label={cancelButtonText}
            variant="secondary"
            disabled={buttonDisabled}
            handleClick={handleCancel}
          />
        </div>
      )}
      <div className="flex w-full flex-col">
        {comments && comments.length > 0 && (
          <div>
            <div className="mx-2">
              <Divider />
            </div>
            {comments.map((value, index) => (
              <div key={index}>
                <div className="comment-section relative mx-2 flex rounded-lg bg-grey-10 p-[6px]">
                  {showDeleteButton && authorId === Number(value.addedById) && (
                    <div
                      className={`invisible hover:visible absolute top-[3px] cursor-pointer bg-grey-50 rounded-lg ${
                        deleteButtonPosition === 'right' ? 'right-0' : 'left-1'
                      }`}
                      onClick={() => {
                        setSelectedComment(value.id)
                        setShowDeleteModal(true)
                      }}
                    >

                      <span className="delete-icon rounded">
                        <DeleteIcon />
                      </span>
                    </div>
                  )}
                  <div className="m-0">
                    <pre className="text-dark-gray m-0 whitespace-pre-line break-all text-base font-normal md:text-sm lg:text-sm font-montserrat">
                      {formatCommentWithLinks(value.comment)}
                    </pre>
                  </div>
                </div>
                <div className="ml-2 flex flex-wrap justify-start py-2">
                  <div className="mr-2">
                    <Text
                      label={`${JSON.parse(value.userInfo)?.fullName} |`}
                      type="rowSubTitle"
                    />
                  </div>
                  <div className="mr-2 ">
                    <Text
                      label={`${returnDate(value.date)} |`}
                      type="rowSubTitle"
                    />
                  </div>
                  <Text
                    label={`${returnTime(value.date)}`}
                    type="rowSubTitle"
                  />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {showDeleteModal && (
        <DeleteModal
          closeDeleteModal={closeDeleteModal}
          cancelButtonText={cancelButtonText}
          selectedComment={selectedComment}
          deleteButtonText={deleteButtonText}
          handleDelete={handleDelete}
          deleteModalTitle={deleteModalTitle}
          deleteModalDescription={deleteModalDescription}
          showDeleteModal={showDeleteModal}
        />
      )}
    </div>
  )
}

export default CommentRow
